import ContentIcons from './ContentIcons';

export default ContentIcons;
